export const SHOPIFY_ERRORS ={
    VIDEO_UPLOAD: "Error occurred while uploading video",
    PHOTO_UPLOAD: "Error occurred while uploading photo",
    GENERAL_ERROR: "Error occurred while updating",
    URL_UPDATE: "Error occurred while updating the URL",
}

export const SHOPIFY_SUCCESS = {
    VIDEO_UPLOAD: "Video uploaded successfully",
    PHOTO_UPLOAD: "Photo uploaded successfully",
    GENERAL_SUCCESS: "Updates saved successfully",
    URL_UPDATE: "URL updated successfully",
}

export const INVALID_FORMAT  = "Please enter a valid URL starting with http:// or https://"
export const UPDATE_ERROR = "Could not fetch the latest changes, try log in again"

